export default function(ngModule) {
    ngModule.factory('CashFlow', function($translate, BaseClass, Currencies) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function CashFlow(attributes) {
            _.assign(this, attributes);
        }

        CashFlow.modelName = 'CashFlow';

        BaseClass.apply(CashFlow);

        CashFlow.validates({
            company_id: {
                required: true
            },
            code: {
                required: true
            },
            name: {
                required: true
            },
            amount: {
                required: true,
                numericality: true,
                withinBounds: {
                    message: 'Not a valid amount (-10000) - (10000)',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value <= 10000 && value >= (-10000);
                    }
                }
            },
            tax_percentage: {
                required: true,
                numericality: true,
                format: {
                    regex: {
                        regex: /\d{1,2}(?:[.,]\d{1,2})?/,
                        message: 'not a valid percentage'
                    }
                }
            },
            currency: {
                required: true,
                inclusion: {
                    in: _.map(Currencies, 'code')
                }
            },
            payed_by: {
                required: true
            },
            payed_to: {
                required: true
            },
            count: {
                required: true,
                integer: true,
                withinBounds: {
                    message: 'Not a valid amount 1 - 100',
                    validator: function(value, instance, field) {
                        if (_.isNil(value))
                            return false;
                        return value <= 100 && value >= 1;
                    }
                }
            }
        });

        CashFlow.configureApi('/split/arbitrary/cashflow/:guid', {queryAdmin: '/split/arbitrary/cashflow/company/:company'});

        CashFlow.prototype.toString = function() {
            return this.name;
        };

        return CashFlow;
    });
}
